// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".in-progress-booking-steps .ant-steps-item-title {\n  width: 100%;\n  padding-right: 0;\n}\n.in-progress-booking-steps .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: #d9d9d9;\n}\n.in-progress-booking-steps .ant-steps-item-icon {\n  border-color: #72c040;\n}\n.in-progress-booking-steps .ant-steps-finish-icon {\n  color: #72c040;\n}\n", ""]);
// Exports
module.exports = exports;
